import styled from "styled-components";

const ActionContainer = styled.div`
  text-align: center;
  margin: 2em auto;
`;

export default ActionContainer;
